import { PUSH_APPLICATION_MESSAGE, POP_APPLICATION_MESSAGE } from '@constants/action-types';

const getPushApplicationMessageAction = message => ({ type: PUSH_APPLICATION_MESSAGE, message });

const getPopApplicationMessageAction = () => ({ type: POP_APPLICATION_MESSAGE });

export const pushApplicationMessage = message => dispatch => dispatch(getPushApplicationMessageAction(message));

export const popApplicationMessage = () => dispatch => dispatch(getPopApplicationMessageAction());
